import InfoOutlined from "@mui/icons-material/InfoOutlined";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import MUITooltip from "@mui/material/Tooltip";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import { FlexColumnDiv } from "./common.styles";
import { HXMobileButton } from "./HXButton";
import { TinyTextLighter as DefaultTinyTextLighter, mobilePageHPadding } from "./HXMobilePage.styles";
const radioIconSize = 42;
export const Parent = styled(FlexColumnDiv) `
    gap: 16px;
    position: relative;
    padding-bottom: 40px;
`;
export const Content = styled(FlexColumnDiv) `
    gap: 24px;
    padding: 0 ${mobilePageHPadding}px;
`;
export const RadioIcon = styled(Radio) `
    width: ${radioIconSize}px;
    height: ${radioIconSize}px;
`;
export const InfoOutlinedIcon = styled(InfoOutlined) `
    width: 24px;
    height: 24px;
    color: ${colors.black_lighter};
    display: block;
`;
export const Tooltip = styled(MUITooltip) ``;
export const TooltipContent = styled(FlexColumnDiv) `
    width: 200px;
`;
export const FormControlLabel = styled(MUIFormControlLabel) `
    align-self: stretch;
    .MuiSvgIcon-root {
        width: 24px;
        height: 24px;
    }

    &.MuiFormControlLabel-labelPlacementEnd {
        margin-left: 0; // There's a default -11 left-margin
    }
`;
export const TinyTextLighter = styled(DefaultTinyTextLighter) `
    margin-left: ${radioIconSize}px;
`;
export const SaveButton = styled(HXMobileButton).attrs({ text: true, loaderColor: colors.navy_main }) `
    align-self: flex-end;
`;
export const TwilioFromPhoneNumber = styled.span `
    text-decoration-line: underline;
`;
const DialogText = styled.div `
    font-size: ${fontSizes.TINY};
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.4px;
`;
export const SpinnerText = styled(DialogText) `
    color: ${colors.black_lighter};
`;
export const DialogFooter = styled(DialogText) `
    color: ${colors.black_main};
`;
export const ConfirmDialogLink = styled.span `
    text-decoration-line: underline;
    cursor: pointer;
`;
